import React, { useMemo } from 'react';
import DeviationMediaService from '../../../utils/DeviationMediaService';
const ImageInlineView = ({ deviation, width: propWidth, height: propHeight, crop = 'fill' })=>{
    const thumb = useMemo(()=>{
        return DeviationMediaService.getSmallestThumbThatFullyCovers(deviation, propWidth, propHeight !== null && propHeight !== void 0 ? propHeight : Infinity, (t)=>t[t.length - 1], {
            thumbTypes: [
                '375W',
                '414W',
                '750W',
                '828W'
            ]
        });
    }, [
        deviation,
        propHeight,
        propWidth
    ]);
    if (!thumb) {
        return /*#__PURE__*/ React.createElement("span", null, "Failed to render");
    }
    var _thumb_width, _thumb_height;
    return /*#__PURE__*/ React.createElement("img", {
        loading: "lazy",
        src: thumb.src,
        alt: deviation.title,
        width: Math.min((_thumb_width = thumb.width) !== null && _thumb_width !== void 0 ? _thumb_width : Infinity, propWidth),
        height: Math.min((_thumb_height = thumb.height) !== null && _thumb_height !== void 0 ? _thumb_height : Infinity, propHeight),
        style: {
            objectFit: crop,
            verticalAlign: 'bottom'
        }
    });
};
ImageInlineView.displayName = 'ImageInlineView';
export default ImageInlineView;

//# sourceMappingURL=Image.js.map